import state from './appointmentState'
import mutations from './appointmentMutations'
import actions from './appointmentActions'
import getters from './appointmentGetters'

export default {
	namespaced: true,
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters
}
